import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Safe access to env vars - Vite provides types via vite/client
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Export a flag so other components know if Auth is active
export const isSupabaseConfigured = !!supabaseUrl && !!supabaseAnonKey;

let client: SupabaseClient | null = null;

if (isSupabaseConfigured) {
  try {
    client = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  } catch (error) {
    console.error('Supabase Client Init Failed:', error);
    client = null;
  }
} else {
  console.warn('Supabase credentials missing. Auth features will be disabled.');
}

// Export as nullable. Consumers must check for null or use AuthContext.
export const supabase = client;
